import {
  MATCH_ITEM,
  CONTEST_FILTER,
  SET_MY_TEAM_LIST,
  SET_CONTEST_TYPES,
  SET_CONTEST_CATEGORIES,
  SET_MY_CONTEST_LIST,
  SET_INITIAL_DATA,
  SET_ALL_CONTEST_LIST
} from '../actions/fantasy-football-action-types';

const initialState = {
  item: {},
  contestFilter: {},
  isAppliedFilter: false,
  myTeamList: [],
  myContestList: [],
  allContestList: [],
  contestListByCategory: [],
  playerList: [],
  contestTypes: {},
  leaderboard: [],
  list: []
};

export default function fantasy(state: any = initialState, action: { type: any; payload: any }) {
  switch (action.type) {
    case MATCH_ITEM: {
      const item = action.payload;
      return {
        ...state,
        item: { ...item }
      };
    }
    case CONTEST_FILTER: {
      return {
        ...state,
        contestFilter: action.payload
      };
    }
    case SET_MY_TEAM_LIST: {
      const { matchId, teamData, teamId = '', isEdit = false } = action.payload;
      if (isEdit) {
        const currentMatchList = [...state.myTeamList[matchId]];
        const idx = currentMatchList.findIndex((item: any) => item.id === teamId);
        currentMatchList.splice(idx, 1);
        const afterEditMatchList = [...currentMatchList, teamData];

        return {
          ...state,
          myTeamList: { ...state.myTeamList, [matchId]: afterEditMatchList }
        };
      } else {
        const currentMatchList = [...state.myTeamList[matchId]];

        return {
          ...state,
          myTeamList: {
            ...state.myTeamList,
            [matchId]: [...currentMatchList, teamData]
          }
        };
      }
    }
    case SET_CONTEST_TYPES: {
      return {
        ...state,
        contestTypes: action.payload
      };
    }
    case SET_CONTEST_CATEGORIES: {
      return {
        ...state,
        contestCategories: action.payload
      };
    }
    case SET_MY_CONTEST_LIST: {
      const { matchId, contest } = action.payload;
      const currentMyContestList = [...state.myContestList[matchId]];
      const contestIdx = currentMyContestList.findIndex((item: any) => item._id == contest._id);
      let contestListAfterEdit = [];
      if (contestIdx === -1) {
        contestListAfterEdit = [
          ...currentMyContestList,
          { ...contest, filledTeamSlots: contest.filledTeamSlots + 1 }
        ];
      } else {
        contestListAfterEdit = [...currentMyContestList];
        const temp = {
          ...currentMyContestList[contestIdx],
          filledTeamSlots: currentMyContestList[contestIdx].filledTeamSlots + 1
        };
        contestListAfterEdit[contestIdx] = temp;
      }
      const tempContest = {
        ...contest,
        filledTeamSlots: contest.filledTeamSlots + 1
      };

      const contestCategoryIdx = state.contestListByCategory[matchId].findIndex(
        (item: any) => item._id == contest.contestCategoryId
      );
      const currentContestIdx = state.contestListByCategory[matchId][
        contestCategoryIdx
      ].contests.findIndex((item: any) => item._id === contest._id);
      let tempContestListByCategory = JSON.parse(JSON.stringify(state.contestListByCategory));
      tempContestListByCategory[matchId][contestCategoryIdx].contests[currentContestIdx] =
        tempContest;

      return {
        ...state,
        myContestList: {
          ...state.myContestList,
          [matchId]: [...contestListAfterEdit]
        },
        contestListByCategory: tempContestListByCategory
      };
    }
    case SET_ALL_CONTEST_LIST:
      return {
        ...state,
        allContestList: [...action.payload]
      };
    case SET_INITIAL_DATA: {
      const {
        contestFilter = {},
        myTeamList = [],
        myContestList = [],
        allContestList = [],
        contestListByCategory = [],
        playerList = [],
        contestTypes = {},
        leaderboard = [],
        list = []
      } = action.payload;
      return {
        ...state,
        contestFilter,
        myTeamList,
        myContestList,
        allContestList,
        contestListByCategory,
        playerList,
        contestTypes,
        leaderboard,
        list
      };
    }
    default:
      return state;
  }
}
